import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledPlayerLevelsWrapper = styled(Box)`
  max-width: 900px;
  margin-top: 5px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
` as any;
